import {React,useContext,useEffect,useState} from 'react';
import { FaAward } from 'react-icons/fa';
import { VscFolderLibrary } from 'react-icons/vsc';
import me2 from '../../assets/IMG_3945.jpg';
import './intro.css';
import {UserContext} from '../../App'
import Spinner from '../utility/spinner';


const Intro = () => {
  const [loading, setLoading] = useState(true);
  const value = useContext(UserContext);  
  const [years, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const startDate = new Date('2021-12-13');
  
  const getTime = () => {
    const time =  Date.now() - Date.parse(startDate);
    const currentDate = new Date(); // Current date
    let differenceInMilliseconds = Math.abs(currentDate - startDate);
    differenceInMilliseconds -= years * (1000 * 60 * 60 * 24 * 365)
    const months = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24 * 30));
    differenceInMilliseconds -= months * (1000 * 60 * 60 * 24 * 30);

    setYear(Math.floor(time / (1000 * 60 * 60 * 24)/365).toFixed());
    setMonth(months )
    setDays(currentDate.getDate() - startDate.getDate())
    setHours(currentDate.getHours());
    setMinutes(currentDate.getMinutes());
    setSeconds(currentDate.getSeconds());
    setLoading(false)
  };
  useEffect(() => {
    const interval = setInterval(() => getTime(startDate), 1000);
    return () => clearInterval(interval);
  });

  return (
    <div>
      {loading ?<Spinner /> :
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={value?.profile_url ? value.profile_url : me2} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small> {years} Year {month} Month {days} Day {hours} Hour <br /> {minutes} Min {seconds} Sec</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>
          <p className='about_text'>I’ve spent the last several months in a Office environment, working with NodeJs, NestJs, ExpressJs, TypeScript, Postgresql, MongoDB,Firebase
            HTML, CSS, JavaScript, building everything from landing pages to APIs. My experience as a Software Engineer and Team Leader helped me collaborate with fellow developers from all over the world. Additionally, working with kids isn’t an easy task, however, it has helped me become efficient, productive, and fast even in a very stressful environment, which is an important skill in the tech industry.</p>
          <a href="#contact" className="btn btn-primary">Let's Talk</a>
        </div>
      </div>
    </section>
}
    </div>
  )
}

export default Intro
